import type { PrivateEventForm } from './usePrivateEventForm';

/**
 * The submit-failure banner. A refusal can send the drawer back to an earlier
 * step than the one the submit happened from, so this renders on every step —
 * otherwise the message would be left behind on a step nobody is looking at.
 */
export default function FormErrorBanner({ form }: { form: PrivateEventForm }) {
  if (!form.formError) return null;
  return (
    <p role="alert" style={{ margin: '12px 0 0', fontSize: 12, color: 'var(--nb-risk)' }}>
      {form.formError}
    </p>
  );
}
